export default "__VITE_ASSET__5fb3ef69__"